import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { message, Upload, Switch, Select, DatePicker, Form, Input } from 'antd';
import { LeftCircleOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { app } from '../../config';
import useFetchCountries from '../../hooks/fetchCountries';
import getStateById from '../../hooks/getStateById';
// const { MonthPicker, RangePicker } = DatePicker;
const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};
const beforeUpload = (file) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }
  return isJpgOrPng && isLt2M;
};
const { TextArea } = Input;
const EditState = () => {
  const { t } = useTranslation(['common']);
  const dateFormat = 'MM-DD-YYYY';
  const [uploadObj, setUploadObj] = useState({});
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [uploadedImg, setUploadedImg] = useState('');
  let user = JSON.parse(localStorage.getItem('user'));
  let stateId = JSON.parse(localStorage.getItem('stateId'));
  //   const s=useFetchStates();
  // const states=s.response?s.response.data:[];
  const c = useFetchCountries();
  const countries = c.response ? c.response.data : [];
  let s = getStateById(stateId);
  console.log(s);
  let stateObj = s.response ? s.response.data : null;
  console.log(stateObj);
  // let causeId=2
  // let ca = getCauseById(causeId);
  // let causeObj = ca.response ? ca.response.data : {};
  // if (causeObj.validityDate) console.log(causeObj.validityDate.split('T')[0]);
  // console.log(causeObj);
  // const o = useFetchOrganizations();
  // const orgs = o.response ? o.response.data : [];
  // console.log(orgs);
  // const cc = useFetchCauseCategories();
  // const causeCat = cc.response ? cc.response.data : [];
  // console.log(causeObj);
  // const c = useFetchCauseCategories();
  // console.log(c);
  let causes = c ? c.response : [];
  console.log(causes);
  let navigate = useNavigate();
  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      info.file ? setUploadedImg(info.file.response.data.Location) : ' ';
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  console.log(uploadedImg);
  // console.log(causeCat[0].cause_category);

  const uploadData = async (uploadObj) => {
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/state/update/${stateId}`, uploadObj);
      window.alert(res.data.message);
      if (res.data.statusCode === 200) navigate('/state/view');
    } catch (err) {
      console.log(err);
      // if (err) window.alert(err.response.data.data.message);
      // else retrun;
    }
  };
  console.log(imageUrl);
  const onFinish = (values) => {
    console.log('Success:', values);
    setUploadObj({
      name: values.name ? values.name : '',
      // stateId: values.stateId ? values.stateId : '',
      countryId: values.countryId ? values.countryId : '',
      // image: uploadedImg? uploadedImg : causeObj.image,
      // validityDate: values.validityDate ? values.validityDate.format().split('T')[0] : causeObj.validityDate,
      isActive: values.isActive === true ? 1 : 0,
      // description: values.description ? values.description : '',
      updatedByUserId: user.userId,
    });
  };
  console.log(uploadObj);
  if (Object.keys(uploadObj).length > 0) uploadData(uploadObj);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const renderList = []; //For testing purposes
  return (
    //   <div className='col-lg-9 mt-4 tbl p-4'>
    //   <div className='fs-3 text-center mb-4 fw-bold'>{t('Update State')}</div>
    // {s.response?
    //     <Form
    //           name='basic'
    //           labelCol={{
    //             span: 8,
    //           }}
    //           wrapperCol={{
    //             span: 16,
    //           }}
    //           style={{
    //             maxWidth: 600,
    //           }}
    //           initialValues={{
    //             remember: true,
    //             ['name']: stateObj.name,
    //             ['stateId']: stateObj.stateId,
    //             ['countryId']:stateObj.countryId,
    //             ['isActive']: stateObj.isActive===1?true:false,
    //           }}
    //           onFinish={onFinish}
    //           onFinishFailed={onFinishFailed}
    //           autoComplete='off'
    //         >
    //           <Form.Item
    //             colon={false}
    //             label='State Name'
    //             name='name'
    //             rules={[
    //               {
    //                 required: true,
    //                 message: 'Please input your username!',
    //               },
    //             ]}
    //           >
    //             <Input />
    //           </Form.Item>
    //           {/* <Form.Item
    //             label='State'
    //             name='stateId'
    //             rules={[
    //               {
    //                 required: true,
    //               },
    //             ]}
    //           >
    //             <Select
    //               listHeight={250}
    //               listItemHeight={500}
    //               placeholder="Select"
    //               style={{
    //                 width: 160,
    //               }}
    //             >
    //               {states.map((state) => {
    //                 return (
    //                   <Option key={state.stateId} value={state.stateId}>
    //                     {state.name}
    //                   </Option>
    //                 );
    //               })}
    //             </Select>
    //           </Form.Item> */}
    //           <Form.Item
    //             label='Country'
    //             name='countryId'
    //             rules={[
    //               {
    //                 required: true,
    //               },
    //             ]}
    //           >
    //             <Select
    //               listHeight={250}
    //               listItemHeight={500}
    //               placeholder="Select"
    //               style={{
    //                 width: 160,
    //               }}
    //             >
    //               {countries.map((country) => {
    //                 return (
    //                   <Option key={country.countryId} value={country.countryId}>
    //                     {country.name}
    //                   </Option>
    //                 );
    //               })}
    //             </Select>
    //           </Form.Item>
    //           {/* <Form.Item label='Image' name='image'>
    //             <Upload
    //               // name="avatar"
    //               listType='picture-card'
    //               className='avatar-uploader'
    //               showUploadList={false}
    //               action='https://www.mocky.io/v2/5cc8019d300000980a055e76'
    //               beforeUpload={beforeUpload}
    //               onChange={handleChange}
    //             >
    //               {imageUrl ? (
    //                 <img
    //                   src={imageUrl}
    //                   alt='avatar'
    //                   style={{
    //                     width: '100%',
    //                   }}
    //                 />
    //               ) : (
    //                 uploadButton
    //               )}
    //             </Upload>
    //           </Form.Item> */}

    //           <Form.Item label='Active' valuePropName='checked'  colon={false} name='isActive'>
    //             <Switch />
    //           </Form.Item>
    //           <Form.Item
    //             wrapperCol={{
    //               offset: 8,
    //               span: 16,
    //             }}
    //             colon={false}
    //           >
    //             <button type='primary' class='btn btn-primary button' htmlType='submit'>
    //               Submit
    //             </button>
    //           </Form.Item>
    //         </Form>
    // :" "}

    //   </div>
    <div class='container'>
      <div class='row mt-4 w-75 tbl'>
        <div class='row topbar ' style={{ height: '70px' }}>
          <div class='col-lg-4 fs-3 fw-bold'>
            {' '}
            <LeftCircleOutlined
              onClick={() => {
                navigate('/state/view');
              }}
              className='mt-3 ml-4 back-icon'
              style={{ fontSize: '38px' }}
            />
          </div>
          <div class='col-lg-7 fs-3 fw-bold '>
            <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Update State')} </h2>
          </div>{' '}
        </div>
        <div class='col-lg-11 mb-5 mt-3 '>
          <div class='col-lg-9 align-self-center mt-2 mb-4'>
            {s.response ? (
              <Form
                name='basic'
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 16,
                }}
                style={{
                  maxWidth: 600,
                }}
                initialValues={{
                  remember: true,
                  ['name']: stateObj.name,
                  ['stateId']: stateObj.stateId,
                  ['countryId']: stateObj.countryId,
                  ['isActive']: stateObj.isActive === 1 ? true : false,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete='off'
              >
                <Form.Item
                  colon={false}
                  label='State Name'
                  name='name'
                  rules={[
                    {
                      required: true,
                      message: 'Enter State',
                    },
                  ]}
                >
                  <Input placeholder='Enter State' />
                </Form.Item>
                {/* <Form.Item
              label='State'
              name='stateId'
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                listHeight={250}
                listItemHeight={500}
                placeholder="Select"
                style={{
                  width: 160,
                }}
              >
                {states.map((state) => {
                  return (
                    <Option key={state.stateId} value={state.stateId}>
                      {state.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item> */}
                <Form.Item
                  label='Country'
                  name='countryId'
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    listHeight={250}
                    listItemHeight={500}
                    disabled={true}
                    placeholder='Select Country'
                    style={{
                      width: 160,
                    }}
                  >
                    {countries.map((country) => {
                      return (
                        <Option key={country.countryId} value={country.countryId}>
                          {country.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                {/* <Form.Item label='Image' name='image'>
              <Upload
                // name="avatar"
                listType='picture-card'
                className='avatar-uploader'
                showUploadList={false}
                action='https://www.mocky.io/v2/5cc8019d300000980a055e76'
                beforeUpload={beforeUpload}
                onChange={handleChange}
              >
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt='avatar'
                    style={{
                      width: '100%',
                    }}
                  />
                ) : (
                  uploadButton
                )}
              </Upload>
            </Form.Item> */}

                <Form.Item label='Active' valuePropName='checked' colon={false} name='isActive'>
                  <Switch />
                </Form.Item>
                <Form.Item
                  wrapperCol={{
                    offset: 8,
                    span: 16,
                  }}
                  colon={false}
                >
                  <button type='primary' class='btn btn-primary button' htmlType='submit'>
                    Update
                  </button>
                </Form.Item>
              </Form>
            ) : (
              ' '
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditState;
